import { Typography } from "@mui/material";
import API from "../api";
import { startToast, updateToastSuccess } from '../utils/notification-loading';

// The old "Search by IP" page was removed and absorbed into the Assets Inventory
// (network-status/status) — every internal-IP click across the app should land
// here, filtered to that IP, using the same `?filters=[...]` convention Overview's
// drill-down already uses (Status/index.jsx reads it once on mount).
export const inventoryIpUrl = (ip) => {
  const isReseller = sessionStorage.getItem("type") === "reseller";
  const base = isReseller ? "/reseller/myC/status" : "/user/network-status/status";
  const filters = encodeURIComponent(JSON.stringify([{ field: "ip", operator: "equals", value: ip }]));
  return `${base}?filters=${filters}`;
};

export const handleCellIPClick = async (params, type, resellerHighlights = false) => {
  if (resellerHighlights) {
    API.postCurrentCustomer({ serial_number: params.row.matricola }).then(res => {
      window.sessionStorage.setItem('customerName', params.row.ragioneSociale);

      if (params.field === 'ipDestinatario' || params.field === 'ipAttaccante') {
        if (!/^(255\.|224\.|0\.)/.test(params.formattedValue)) {
          let ip = "";
          if(params.formattedValue.includes(":")){
            ip = params.formattedValue.split(':')[0];
          }
          if (/^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}$|192\.168\.\d{1,3}\.\d{1,3}$|172\.(1[6-9]|2[0-9]|3[0-1])\.\d{1,3}\.\d{1,3}$)/.test(ip)) {
            // IP interno
            window.sessionStorage.setItem("selectedTab", "Inventory");
            window.location.href = inventoryIpUrl(ip);
          } else {
            // IP esterno
            window.sessionStorage.setItem("selectedTab", "Intelligence");
            if (window.sessionStorage.getItem("type") === 'user')
              window.location.href = `/user/extra/map?ip=${ip}`;
            else if (window.sessionStorage.getItem("type") === 'reseller')
              window.location.href = `/reseller/myC/extra/map?ip=${ip}`;
          }
        }
      } else if (params.field === 'dettaglio') {
        navigator.clipboard.writeText(params.formattedValue);
        startToast();
        updateToastSuccess("Detail copied to clipboard");
      }
    }).catch(err => {
      console.error('[handleCellIPClick] Request failed:', err);
    });
  } else {
    if (params.field === 'dest_ip' || params.field === 'src_ip') {
      if (!/^(255\.|224\.|0\.)/.test(params.formattedValue)) {
        let ip = params.value;
          if(params?.formattedValue?.includes(":")){
            ip = params.formattedValue.split(':')[0];
          }
        if (/^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}$|192\.168\.\d{1,3}\.\d{1,3}$|172\.(1[6-9]|2[0-9]|3[0-1])\.\d{1,3}\.\d{1,3}$)/.test(ip)) {
          // IP interno
          window.sessionStorage.setItem("selectedTab", "Inventory");
          window.location.href = inventoryIpUrl(ip);
        } else {
          // IP esterno
          window.sessionStorage.setItem("selectedTab", "Intelligence");
          if (window.sessionStorage.getItem("type") === 'user')
            window.location.href = `/user/extra/map?ip=${ip}`;
          else if (window.sessionStorage.getItem("type") === 'reseller')
            window.location.href = `/reseller/myC/extra/map?ip=${ip}`;
        }
      }
    } else if (params.field === 'signature') {
      // navigator.clipboard.writeText(params.formattedValue);
      startToast();
      updateToastSuccess("Detail copied to clipboard");
    }
  }
};


export function downloadPdf(data, name) {
  const blob = new Blob([data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${name}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export const TOEstablishTheColorOfLog = (detail) => {
  let colorLog = 'white'
  let cellValueLower = detail?.toLowerCase() || "";
  if (
    cellValueLower.includes("malware ") ||
    cellValueLower.includes("metasploit ") ||
    cellValueLower.includes("zerologon ") ||
    cellValueLower.includes("ernalblue ") ||
    cellValueLower.includes("eternalblue ") ||
    cellValueLower.includes("mirai ") ||
    cellValueLower.includes("cobalt ") ||
    cellValueLower.includes("wannacry ") ||
    cellValueLower.includes("reverse shell ") ||
    cellValueLower.includes("mware ")
  ) {
    colorLog = '#DB4F4A'
  } else if (
    cellValueLower.includes("scan ") ||
    cellValueLower.includes("mining ") ||
    cellValueLower.includes("powershell ") ||
    cellValueLower.includes("pivot ") ||
    cellValueLower.includes("shellcode ")
  ) {
    colorLog = '#C9B85E'
  } else if (
    cellValueLower.includes("trojan ") ||
    cellValueLower.includes("system32 ") ||
    cellValueLower.includes("hkey ") ||
    cellValueLower.includes("bin ") ||
    cellValueLower.includes("sh ") ||
    cellValueLower.includes("cve ") ||
    cellValueLower.includes("polymor ") ||
    cellValueLower.includes("nbios ") ||
    cellValueLower.includes("buffer ") ||
    cellValueLower.includes("exploit ")
  ) {
    colorLog = '#F57F22'
  }
  return colorLog
}

export function parseDate(dateStr) {
  const [datePart, timePart] = dateStr.split(', ');
  const [day, month, year] = datePart.split('/').map(Number);
  const [hours, minutes, seconds] = timePart.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
}


export const filterColumns = ({ field, columns, currentFilters }) => {
  // remove already filtered fields from list of columns
  const filteredFields = currentFilters?.map((item) => item.field);
  return columns
    .filter(
      (colDef) =>
        colDef.filterable &&
        (colDef.field === field || !filteredFields.includes(colDef.field)),
    )
    .map((column) => column.field);
};

export const getColumnForNewFilter = ({ currentFilters, columns }) => {
  const filteredFields = currentFilters?.map(({ field }) => field);
  const columnForNewFilter = columns
    .filter(
      (colDef) => colDef.filterable && !filteredFields.includes(colDef.field),
    )
    .find((colDef) => colDef.filterOperators?.length);
  return columnForNewFilter?.field ?? null;
};

export const renderTypeCell = params => {
  const type = ["High", "Critical", "Alert", "Movements", "Threat Intelligence", "Infrastructure Log" ][params.value] || "";
  const color = ["#FEA51D", "#931A1D", "#D1C167", "#459296", "#C485BF", ""][params.value] || "inherit";
  return <Typography style={{ color }}>{type}</Typography>;
};


export function hasExternalIp(ip1, ip2) {
  const stripPort = (ip) => ip.split(':')[0];
  const internalIpPattern = /^(10\.|172\.(1[6-9]|2[0-9]|3[0-1])\.|192\.168\.)/;
  const isExternalIp = (ip) => !internalIpPattern.test(stripPort(ip));
  return isExternalIp(ip1) || isExternalIp(ip2);
}

export function isInternalIp(ip) {
  if(!ip) return false;
  ip = ip.toLowerCase();
  if (ip.startsWith("10.") ||
      ip.startsWith("192.168.") ||
      /^172\.(1[6-9]|2\d|3[01])\./.test(ip)) {
    return true;
  }
  if (ip === "::1") return true;
  if (/^(fc|fd)[0-9a-f]{2}/.test(ip)) {
    return true;
  }
  if (ip.startsWith("fe8") || ip.startsWith("fe9") || ip.startsWith("fea") || ip.startsWith("feb")) {
    return true;
  }

  return false;
}

